<template>
    <div class="sales-card-gallery">
        <div class="sales-card-section-title"><h2>{{ salesCardArr.project_page_in.gallery_title  }}</h2></div>
        <div class="gallery-carousel">
            <swiper :options="swiperOption" ref="galleryCardCarousel" v-if="!isMobileChecker">
                <swiper-slide v-for="(slide, index) in salesCardArr.project_page_in.gallery_images" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <swiper :options="swiperOptionMobile" ref="galleryCardCarouselMobile" v-if="isMobileChecker">
                <swiper-slide v-for="(slide, index) in salesCardArr.project_page_in.gallery_images_mobile" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <div class="swiper-controls sales-card-gallery-controls" v-if="salesCardArr.project_page_in.gallery_images.length > 1">
                <div class="sales-card-gallery-btn-prev slider-btn btn-wow-effect-hover">
                    <svgIcon name="arrow-left" class="icon-left-arrow"/>
                </div>
                <div class="sales-card-gallery-btn-next slider-btn btn-wow-effect-hover">
                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                </div>
            </div>
            <div class="swiper-pagination sales-card-gallery-pagination" v-if="salesCardArr.project_page_in.gallery_images.length > 1"></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-gallery',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeSlideChildren: true,
                    observeParents: true,
                    resizeObserver: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-card-gallery-btn-next',
                        prevEl: '.sales-card-gallery-btn-prev',
                    },
                    pagination: {
                        el: '.sales-card-gallery-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
                swiperOptionMobile: {
                    speed: 1000,
                    observer: true,
                    observeSlideChildren: true,
                    observeParents: true,
                    resizeObserver: true,
                    effect: 'slide',
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-card-gallery-btn-next',
                        prevEl: '.sales-card-gallery-btn-prev',
                    },
                    pagination: {
                        el: '.sales-card-gallery-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
            // indexPage: 'loadIndexPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-gallery.scss';
    @import '@/styles/components/sales-card/respond/sales-card-gallery-respond.scss';
    // @import '@/styles/components/sales-card/respond/sales-card-prems-respond.scss';
    // @import '@/styles/components/sales-card/respond/sales-card-about-respond.scss';
</style>